import React, { useState, useEffect } from "react";
import { CardBasic, CustomCheck, Select, PrimaryButton } from "extranet-component-library";
import { useTranslation } from "react-i18next";
import { useStores } from "../hooks/useStores";
import { isMobile } from "../utils/parsers";


interface CustomProps {
    settings: any
}

const ProfileConfig = ({ settings }: CustomProps) => {
    const { t } = useTranslation();
    const { myTibStore, translationStore } = useStores();
    const [config, setConfig] = useState({
        language: {},
        emailEnabled: false,
        mailingEnabled: false,
        extranetEnabled: false,
        notifyTimCaducity: false,
        island: "",
    });

    useEffect(() => {
        if (settings) {
            setConfig({
                ...settings,
                language: { id: settings.language, label: t(settings.language) },
            });
        }
    }, [t, settings]);

    const onSettingsSaved = () => {
        const lang: any = config.language;
        const data = {
            ...config,
            language: lang.id,
        };
        myTibStore.updateSettings(data);
        translationStore.setLanguage(lang.id);
    };

    return (
        <CardBasic
            style={{
                width: isMobile() ? "95%" : "90%",
                margin: isMobile() ? "0.5rem" : "",
            }}
            content={
                <>
                    <div className="title">{t("config")}</div>
                    <br />
                    <div className="favs-container wrap">
                        <div className="select-container">
                            <div className="select-title">{t("language")}</div>
                            <Select
                                isMobile={isMobile()}
                                options={[
                                    { id: "es", label: t("es") },
                                    { id: "ca", label: t("ca") },
                                ]}
                                placeholder={t("select_language")}
                                value={config.language}
                                onSelect={(l) => setConfig({ ...config, language: l })}
                            />
                        </div>
                    </div>
                    <div className="title">{t("headers.alerts")}</div>
                    <div className="checks-title">{t("alerts.alert_channel")}</div>
                    <div className="favs-check">
                        <CustomCheck
                            id={t("alerts.alert_email")}
                            label={t("alerts.alert_email")}
                            checked={config.emailEnabled}
                            onCheckboxChanged={(e) =>
                                setConfig({ ...config, emailEnabled: e })
                            }
                        />
                    </div>
                    <div className="favs-check">
                        <CustomCheck
                            id={t("alerts.alert_extranet")}
                            label={t("alerts.alert_extranet")}
                            checked={config.extranetEnabled}
                            onCheckboxChanged={(e) =>
                                setConfig({ ...config, extranetEnabled: e })
                            }
                        />
                    </div>
                    <div className="checks-title">{t("alerts.card_alert")}</div>
                    <div className="favs-check">
                        <CustomCheck
                            id={t("alerts.card_expires_alert")}
                            label={
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: t("alerts.card_expires_alert"),
                                    }}
                                />
                            }
                            checked={config.notifyTimCaducity}
                            onCheckboxChanged={(e) =>
                                setConfig({ ...config, notifyTimCaducity: e })
                            }
                        />
                    </div>
                    <div style={{ textAlign: "center", paddingTop: "3rem" }}>
                        <PrimaryButton
                            text={t("save_settings")}
                            onClick={() => onSettingsSaved()}
                        />
                    </div>
                </>
            }
        />
    );
};

export default ProfileConfig;
